import { IDealDataModel } from '../../../data-models/deal.data-model';
import { ColumnStage } from '../data-models/columnStage.data-model';

export function getDealsForAllStages(dealboardState: ColumnStage[]): IDealDataModel[] {
  return dealboardState.reduce((acc, curr) => {
    return [...acc, ...curr.deals];
  }, [] as IDealDataModel[]);
}
